// helper
import { cut } from "@/helper/getCut";

// Строге перетворення до числа: тільки number або "чистий" числовий рядок
const toNumberStrict = (v) => {
	if (v == null) return 0; // null/undefined → 0
	if (typeof v === 'number') return Number.isFinite(v) ? v : 0;

	if (typeof v === 'string') {
		const s = v.trim();
		if (s === '') return 0;
		// допускаємо ціле або десяткове з крапкою, зі знаком або без
		// приклади валідних: "10", "-10", "0.5", ".5", "-.5"
		if (/^[+-]?(?:\d+\.?\d*|\.\d+)$/.test(s)) {
			const n = Number(s);
			return Number.isFinite(n) ? n : 0;
		}
		return 0; // "sdd", "10 sdd", "sdd 10" → 0
	}

	return 0; // інші типи (bool, obj, тощо) → 0
};

export function getSum(list, key, isCut) {
	const arr = Array.isArray(list) ? list : [];

	const total = arr.reduce((acc, item) => acc + toNumberStrict(item?.[key]), 0);

	// якщо потрібно різати/модифікувати — застосовуємо cut()
	if (isCut) return cut(total);
	return total;
}
